import { AreaUnit, formatArea, IFormattingSettings } from '@fulcrum/lib';
import * as Converter from '../unit-of-measure/area-converter';
import { t } from '@trimble/i18n';
import { BaseFormatterProps } from './base-formatter-props.types';

/**
 * The conversion is achieved by first converting to square meters (m2) as an intermediate step.
 * The 'fulcrum' library uses m2 as its base unit for area.
 *
 * @remarks Trimble APIs should store and return area in base metric.
 *
 * @regex ^-?\d+(\.\d+)?\s?(mm2|cm2|m2|in2|ft2)$
 * - TODO: Refine this regex to better match possible outputs.
 */
export const toDisplay = ({
  measuredValue,
  currentUnits,
  settings,
}: BaseFormatterProps<number, AreaUnit, IFormattingSettings>): string => {
  let measuredValueInMeters;
  if (currentUnits !== 'm2') {
    // Convert to m2 first due to fulcrum lib using m2 as base unit
    measuredValueInMeters = Converter.mapToMeters({
      value: measuredValue,
      baseUnit: currentUnits,
    });
  } else {
    measuredValueInMeters = measuredValue;
  }

  if (measuredValueInMeters !== null) {
    return formatArea(
      measuredValueInMeters,
      settings.areaUnit ?? 'm2',
      settings.areaDecimals
    );
  } else {
    return t('Utilities.Formatting.InvalidUnit', {
      defaultValue: 'Invalid Unit',
    });
  }
};
